export default __webpack_public_path__ + "static/media/completed.eee53cc9.svg";